var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiles({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1589_2446)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 2.25C15.4142 2.25 15.75 2.58579 15.75 3V7C15.75 7.0663 15.7763 7.12989 15.8232 7.17678C15.8701 7.22366 15.9337 7.25 16 7.25H20C20.4142 7.25 20.75 7.58579 20.75 8C20.75 8.41421 20.4142 8.75 20 8.75H16C15.5359 8.75 15.0908 8.56563 14.7626 8.23744C14.4344 7.90925 14.25 7.46413 14.25 7V3C14.25 2.58579 14.5858 2.25 15 2.25Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 3.75C10.6685 3.75 10.3505 3.8817 10.1161 4.11612C9.8817 4.35054 9.75 4.66848 9.75 5V15C9.75 15.3315 9.8817 15.6495 10.1161 15.8839C10.3505 16.1183 10.6685 16.25 11 16.25H18C18.3315 16.25 18.6495 16.1183 18.8839 15.8839C19.1183 15.6495 19.25 15.3315 19.25 15V8.31066L14.6893 3.75H11ZM9.05546 3.05546C9.57118 2.53973 10.2707 2.25 11 2.25H15C15.1989 2.25 15.3897 2.32902 15.5303 2.46967L20.5303 7.46967C20.671 7.61032 20.75 7.80109 20.75 8V15C20.75 15.7293 20.4603 16.4288 19.9445 16.9445C19.4288 17.4603 18.7293 17.75 18 17.75H11C10.2707 17.75 9.57118 17.4603 9.05546 16.9445C8.53973 16.4288 8.25 15.7293 8.25 15V5C8.25 4.27065 8.53973 3.57118 9.05546 3.05546Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 7.75C6.66848 7.75 6.35054 7.8817 6.11612 8.11612C5.8817 8.35054 5.75 8.66848 5.75 9V19C5.75 19.3315 5.8817 19.6495 6.11612 19.8839C6.35054 20.1183 6.66848 20.25 7 20.25H14C14.3315 20.25 14.6495 20.1183 14.8839 19.8839C15.1183 19.6495 15.25 19.3315 15.25 19V17C15.25 16.5858 15.5858 16.25 16 16.25C16.4142 16.25 16.75 16.5858 16.75 17V19C16.75 19.7293 16.4603 20.4288 15.9445 20.9445C15.4288 21.4603 14.7293 21.75 14 21.75H7C6.27065 21.75 5.57118 21.4603 5.05546 20.9445C4.53973 20.4288 4.25 19.7293 4.25 19V9C4.25 8.27065 4.53973 7.57118 5.05546 7.05546C5.57118 6.53973 6.27065 6.25 7 6.25H9C9.41421 6.25 9.75 6.58579 9.75 7C9.75 7.41421 9.41421 7.75 9 7.75H7Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1589_2446"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiles);
export default __webpack_public_path__ + "static/media/Files.0a3628de38ac70bd184194c4b5c94dd2.svg";
export { ForwardRef as ReactComponent };